import {
  MFPClaimsGetParams,
  MFPClaimsUpdateParams
} from '@module-claims/models/mfp-claim.interface';

export class GetMFPClaims {
  static readonly type = '[ MFP Claims ] GetMFPClaims';
  constructor(public params: MFPClaimsGetParams) {}
}

export class ClearMFPClaims {
  static readonly type = '[ MFP Claims ] ClearMFPClaims';
}

export class UpdateMFPClaims {
  static readonly type = '[ MFP Claims ] UpdateMFPClaims';
  constructor(public params: MFPClaimsUpdateParams) {}
}
